module.exports = __webpack_public_path__ + "static/media/cat-yawning.51ac811b.png";